
import React from 'react';

export default {
    translation: {
        common: {
            processing: 'Processing',
            loading: 'Loading',
            here: 'here',
            forgotPassword: 'Forgot your password?',
            approve: 'Approve',
            reject: 'Reject',
            confirmChanges: 'Please confirm - any changes will be final',
            saveSuccessful: 'Save successful!',
            downloadCSV: 'Download displayed data as CSV',
            resultsFilteredTo: 'Bag: {{name}}',
            folders: 'Bags',
            select: 'Select',
            unselect: 'Unselect',
            mb: 'MB',
            removeUsers: 'Remove',
            bytes: 'bytes',
            unavailable: 'Unavailable',
            publidId: 'Public id',
            title: 'Title',
            titleWithAsterisk: 'Title*',
            description: 'Description',
            descriptionWithAsterisk: 'Description*',
            location: 'Location',
            locationWithAsterisk: 'Location*',
            region: 'Region',
            prefecture: 'Prefecture',
            prefectureWithAsterisk: 'Prefecture*',
            mediaSize: 'Media Size',
            orientation: 'Orientation',
            expirationDate: 'Expiration date',
            secondaryUse: 'Secondary Use',
            secondaryUseWithAsterisk: 'Secondary Use*',
            secondaryUseJNTO: 'Secondary Use (JNTO)',
            secondaryUseJNTOWithAsterisk: 'Secondary Use (JNTO)*',
            secondaryUseJOMC: 'Secondary Use (JOMC)',
            secondaryUseMedia: 'Secondary Use (Media)',
            secondaryUseMediaWithAsterisk: 'Secondary Use (Media)*',
            secondaryUseJomcJnto: 'Secondary Use (JomcJnto)',
            secondaryUseJomcJntoWithAsterisk: 'Secondary Use (JomcJnto)*',
            secondaryUseGovernment: 'Secondary Use (Gov)',
            secondaryUseGovernmentWithAsterisk: 'Secondary Use (Gov)*',
            keywords: 'Keywords',
            information: 'Information',
            copywrite: 'Copyright',
            widthAbbreviation: 'W',
            heightAbbreviation: 'H',
            noRequestToDisplay: 'No requests to display yet',
            filesFinishedUploading: 'Your files have finished uploading.',
            thumbnail: 'Thumbnail',
            status: 'Status',
            notes: 'Notes',
            fileName: 'File Name',
            fileNameWithAsterisk: 'File Name*',
            excelFileName: 'Excel File Name',
            photographer: 'Photographer',
            shootingDate: 'Shooting Date',
            shootingDateWithAsterisk: 'Shooting Date*',
            from: 'Asset Owner',
            fromWithAsterisk: 'Asset Owner*',
            purchaseId: 'Purchase Id',
            validDate: 'Expiration Date',
            requestApproval: 'Download Approval \n Required',
            requestApprovalWithAsterisk: 'Download Approval \n Required*',
            approvalRequired: 'APPROVAL IS REQUIRED TO DOWNLOAD THIS ASSET',
            credit: 'Credit',
            creditWithAsterisk: 'Credit*',
            contact: 'Contact',
            copyrightHolder: 'Copyright Holder',
            collectionName: 'Collection Name',
            contentfulId: 'Contentful Id',
            projectId: 'Project',
            projectIdWithAsterisk: 'Project*',
            caption: 'Caption',
            prePostApprovalWithAsterisk: 'Pre Post Approval Required*',
            prePostApproval: 'Pre Post Approval Required',
            trimming: 'Trimming possible',
            trimmingWithAsterisk: 'Trimming possible*',
            rightOfPublicityWithAsterisk: 'Right of Publicity*',
            rightOfPublicity: 'Right of Publicity',
            myProfile: 'My Profile',
            myFolders: 'My Bags',
            myProjects: 'My Projects',
            myRequests: 'Upload Requests',
            myPermissionRequests: 'Download Requests',
            moderation: 'Moderation',
            admin: 'Admin',
            logout: 'Logout',
            uploadAssets: 'Upload Assets',
            manualTags: 'Manual Tags',
            autoTags: 'Auto Tags',
            search: 'Search',
            navigationSearch: 'Search in English',
            next: 'Next',
            previous: 'Previous',
            alt: 'Alt',
            organization: 'Organization',
            organizations: 'Organizations',
            project: 'Project',
            projects: 'Projects',
            user: 'User',
            users: 'Users',
            userDelete: 'User Delete',
            dimensions: 'Dimension W/H (px)',
            fileSize: 'File Size',
            width: 'Width',
            height: 'Height',
            create: 'Create',
            edit: 'Edit',
            remove: 'Remove',
            adminMenu: 'Admin Menu',
            permissionMenu: '-Request Downloads-',
            uploadMenu: '-Upload Assets-',
            stepperRouteValidation: 'Data on your current page could be lost, are you sure?',
            details: 'Details',
            actionRequired: 'Action Required',
            copyrightWithAsterisk: 'Copyright*',
            modelReleaseWithAsterisk: 'Model Release*',
            projectName: "Project Name",
            projectNameWithAsterisk: "Project Name*",
            modelRelease: 'Model Release',
            secondaryUseMunicipality: 'Secondary Use (Municipality)',
            secondaryUseMunicipalityWithAsterisk: 'Secondary Use (Municipality)*',
            color: 'Color adjustment possible',
            colorWithAsterisk: 'Color adjustment possible*',
            text: 'Text integration possible',
            textWithAsterisk: 'Text integration possible*',
            contactOrganization: 'Contact Organization',
            contactRole: 'Contact Role',
            contactname: 'Contact Name',
            contactPhoneNumber: 'Contact Phone Number',
            contactEmail: 'Contact Email',
            attention: 'Attention',
            userGuide: 'User Guide',
            true: 'True',
            false: 'False',
            approvalNeededText: 'Download Approval\nRequired',
            referenceUrl: "Reference URL",
            remark: "Remark",
            approvalForExternalUsage: "Approval for External Usage",
            approvalForExternalUsageWithAsterisk: "Approval for External Usage*",
            departmentInCharge: 'Department in charge',
            departmentInChargeWithAsterisk: 'Department in charge*',
            date: 'Date',
            reset: 'Reset',
            update: 'Update',
            updateUser: 'Update',
            duration:'Duration',
            durationSeconds:" seconds",
            updateSuccess: 'The update has been completed!',
            updateSuccessSub: 'Asset update may take a few minutes to be reflected on J-Photo.',

            // JOMC fields
            theme1: 'Theme1',
            theme1WithAsterisk: 'Theme1*',
            theme2: 'Theme2',
            season: 'Season',
            seasonWithAsterisk: 'Season*',
            tags: 'Tags',
            mediaType: 'Media Type',
            mediaTypeGovernment: 'Media Type Government',
            mediaTypeGovernmentWithAsterisk: 'Media Type Government*',
            mediaTypeMedia: 'Media Type Media',
            mediaTypeMediaWithAsterisk: 'Media Type Media*',
            mediaTypeTravelTrade: 'Media Type Travel Trade',
            mediaTypeTravelTradeWithAsterisk: 'Media Type Travel Trade*',
            location2: 'Location2',
            location2WithAsterisk: 'Location2*',
            availableJOMC: 'Available on JOMC',
            viewMoreTags: 'View More Tags',
            viewMoreDetails: 'View More Details',
        },
        header: {
            dashboard: 'Dashboard',
            upload: 'Upload',
            downloadRequest: 'Download Requests',
            userGuide: 'User Guide',
        },
        sideBar: {
            userInformation: 'User Information',
            user: 'User:',
            email: 'Email:',
            organization: 'Organization:',
            userGroup: 'User Group:',
            contact: 'Contact Support',
            pdf: 'Download Manual in PDF',
            upload: {
                title: 'Assets Upload',
                option: 'Select Option',
                attachAsset: 'Attach Assets',
                attachExcel: 'Attach Excel File',
                upload: 'Upload Assets'
            },
        },
        filters: {
            downloadCount: 'Download Count',
            reset: 'RESET',
            filter: 'Filter',
            assetType: 'Asset type',
            assetRatio: 'Asset ratio',
            prefecture: 'Prefecture',
            assetIdTopBar: 'Asset ID (Please input only one ID per query)',
            assetId: 'Asset ID',
            seasons: 'Season',
            expireDateNo: 'No',
            externalUse: 'Approval for External Usage',
            externalUseApproved: 'Approved for External Usage',
            externalUseDenied: 'External Usage Forbidden',
            externalUseContact: 'Contact the Department in Charge in JNTO',
            checkedExpireDateNo: 'Expiration date: No',
            checkedExpireDateYes: 'Expiration date: Yes',
            downloadPermission: 'Download Approval Required',
            downloadPermissionYes: 'Yes',
            downloadPermissionNo: 'No',
            downloadPermissionYesChecked: 'Download Approval Required: Yes',
            downloadPermissionNoChecked: 'Download Approval Required: No',
            prePostApproval: 'Pre Post Approval Required',
            prePostApprovalYes: 'Yes',
            prePostApprovalNo: 'No',
            prePostApprovalYesChecked: 'Pre Post Approval: Required Yes',
            prePostApprovalNoChecked: 'Pre Post Approval Required: No',
            expireDate: 'Expiration date',
            tags: 'Category',
            image: 'Image',
            video: 'Movie',
            portrait: 'Portrait',
            landscape: 'Landscape',
            square: 'Square',
            spring: 'Spring',
            summer: 'Summer',
            autumn: 'Autumn',
            winter: 'Winter',
            allSeasons: 'All seasons',
            yes: 'Yes',
            no: 'No',
            enterAssetId: 'Enter Asset Id',
            hokkaido: 'Hokkaido',
            akita: 'Akita',
            aomori: 'Aomori',
            fukushima: 'Fukushima',
            iwate: 'Iwate',
            miyagi: 'Miyagi',
            yamagata: 'Yamagata',
            chiba: 'Chiba',
            gunma: 'Gunma',
            ibaraki: 'Ibaraki',
            kanagawa: 'Kanagawa',
            saitama: 'Saitama',
            tochigi: 'Tochigi',
            tokyo: 'Tokyo',
            fukui: 'Fukui',
            ishikawa: 'Ishikawa',
            nagano: 'Nagano',
            niigata: 'Niigata',
            toyama: 'Toyama',
            aichi: 'Aichi',
            gifu: 'Gifu',
            mie: 'Mie',
            shizuoka: 'Shizuoka',
            yamanashi: 'Yamanashi',
            hyogo: 'Hyogo',
            kyoto: 'Kyoto',
            nara: 'Nara',
            osaka: 'Osaka',
            shiga: 'Shiga',
            wakayama: 'Wakayama',
            hiroshima: 'Hiroshima',
            okayama: 'Okayama',
            shimane: 'Shimane',
            tottori: 'Tottori',
            yamaguchi: 'Yamaguchi',
            ehime: 'Ehime',
            kagawa: 'Kagawa',
            kochi: 'Kochi',
            tokushima: 'Tokushima',
            fukuoka: 'Fukuoka',
            kagoshima: 'Kagoshima',
            kumamoto: 'Kumamoto',
            miyazaki: 'Miyazaki',
            nagasaki: 'Nagasaki',
            oita: 'Oita',
            saga: 'Saga',
            okinawa: 'Okinawa',
            foodDrink: 'Food and drink',
            shopping: 'Shopping',
            tag1: "Food and drink",
            tag2: "Shopping",
            tag3: "Historic sites",
            tag4: "Architecture",
            tag5: "Art",
            tag6: "Theme parks",
            tag7: "Cities",
            tag8: "Entertainment",
            tag9: "Subculture",
            tag10: "Fashion",
            tag11: "Tradition",
            tag12: "Skills and knowledge'",
            tag13: "Local lifestyle",
            tag14: "Festival",
            tag15: "Sports",
            tag16: "Outdoors",
            tag17: "Resorts",
            tag18: "Nature",
            tag19: "Nightlife",
            tag20: "Hot springs",
            historicSites: 'Historic sites',
            architecture: 'Architecture',
            art: 'Art',
            themeParks: 'Theme parks',
            cities: 'Cities',
            entertainment: 'Entertainment',
            subculture: 'Subculture',
            fashion: 'Fashion',
            tradition: 'Tradition',
            skillsKnowledge: 'Skills and knowledge',
            localLifestyle: 'Local lifestyle',
            festival: 'Festival',
            sports: 'Sports',
            outdoors: 'Outdoors',
            resorts: 'Resorts',
            nature: 'Nature',
            nightlife: 'Nightlife',
            hotSprings: 'Hot springs',
            fuzzySearch: 'Fuzzy search',
            tooptipFuzzy: "What is fuzzy search?",
            tooptipFuzzyDetail: "Even if the keyword you are searching for is not an exact match, results with similar keywords will be shown.   For example, searches that include misspellings, synonyms, or related words can return relevant information.",
            tooptipKeyword: "Searchable keywords",
            tooptipKeywordDetail: "Searchable keywords include any information stored in the metadata of an asset. For example, this can include asset tags, asset descriptions, location information, details related to the source of an asset, or other information that is stored about the asset. ",
        },
        auth: {
            signin: {
                noAccount: "Don't have an account? Sign up",
                welcomeBack: 'Welcome back!'
            },
            signup: {
                alreadyHaveAccount: 'Already have an account? Sign in',
                signupHere: 'Please sign up here',
            },
            forgotPassword: {
                backToSignin: 'Back to sign in',
                resetPassword: 'Reset Your Password',
            }
        },
        termsAndConditions: {
            termsAndConditions: 'Terms of Use',
            agreedToTerms: 'Agreed to terms',
            download: {
                downloadTerms: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum vel libero ac quam pulvinar blandit. Mauris varius nisi et augue vehicula vulputate. Ut volutpat molestie quam. Pellentesque urna elit, feugiat id ante quis, sodales fermentum arcu. Nam pellentesque eleifend ligula, at interdum risus tincidunt et. Suspendisse sit amet urna nec purus tempor luctus non nec felis. Nullam eget aliquam sapien. Proin eleifend nulla nec tortor venenatis, ac egestas augue mollis. Curabitur sed justo bibendum, tempor nibh a, faucibus arcu. Nulla sit amet urna quis velit sollicitudin dignissim. Mauris volutpat rhoncus velit, rutrum finibus enim posuere eu. Duis accumsan ex velit, molestie finibus nibh dignissim ut. Nunc malesuada luctus sem. Donec luctus dolor ac ipsum iaculis faucibus. Pellentesque in purus eget est maximus sollicitudin. Morbi eget tempus mauris. Sed mauris mi, aliquam at leo quis, scelerisque ultrices turpis. Suspendisse vulputate dui non ante finibus, efficitur vulputate magna finibus. Quisque at elementum risus. Curabitur lacinia dui magna, at accumsan velit ultrices id. Mauris tempor imperdiet est in varius. Sed diam sapien, placerat ac eleifend a, sollicitudin ornare ipsum. Aenean lacinia ipsum eget orci tincidunt, vitae eleifend ipsum varius. Proin turpis turpis, faucibus at consequat in, interdum rhoncus magna. Duis quis nisi hendrerit, faucibus justo eu, ultricies justo. Cras in tortor est. Mauris mattis pellentesque orci. Pellentesque semper eros eget ornare facilisis. Nulla in nulla nec nisi blandit laoreet. Cras nec odio imperdiet, auctor nibh at, sollicitudin ante. Donec metus diam, vehicula vel leo nec, mattis efficitur nisi. Morbi luctus augue lorem, non gravida tellus fringilla at. Nullam id pharetra diam, nec scelerisque purus. Praesent sed eleifend leo. Fusce elementum ante id odio finibus, eget iaculis diam iaculis. Maecenas quis vestibulum mauris. Aenean justo sapien, porta at volutpat eleifend, interdum ut tellus. Quisque commodo, elit vitae lobortis commodo, lacus tortor volutpat eros, hendrerit semper nibh massa quis enim. Fusce ut gravida lectus. Suspendisse potenti. Pellentesque posuere odio nibh. Phasellus suscipit, tortor sollicitudin rhoncus gravida, eros sem tempus ex, sit amet fringilla nulla lorem a ligula. Maecenas vitae odio in velit auctor rutrum et id dolor. Aliquam at ultrices nulla. Vestibulum sed pretium erat. Ut feugiat condimentum urna a vehicula. Proin arcu mi, vestibulum et augue eget, fringilla ultrices ligula. Proin molestie vestibulum purus at faucibus. Fusce sapien est, varius a hendrerit sit amet, dictum vel nisl. Etiam ac augue semper, finibus odio quis, porttitor tortor. Aliquam ut orci vel eros pellentesque hendrerit. Maecenas rhoncus libero arcu, eget consectetur neque elementum ut. Nulla rutrum porta volutpat.',
                downloadAgree: ' I agree to the terms and conditions',
            }
        },
        faq: {
            faqcategory1: 'General',
            faqcategory2: 'Upload',
            faqcategory3: 'Download',
            faqQuestion1: 'Q: What is Digital Asset Management?',
            faqAnswer1: 'A: Digital Asset Management is a system that stores, shares and organizes digital assets in a central location.',
            faqQuestion2: 'Q: What is an asset?',
            faqAnswer2: 'A: An asset is a file such as a video, music, photo, documents, etc. which contain the rights to use them.',
            faqQuestion3: 'Q: How can I contact support team?',
            faqAnswer3: 'A: You can contact the support team via phone or email. The details are as follows: \n Tel: 03-6804-2655 \n Email: jphoto-inquiry@jnto.go.jp',
            faqQuestion4: 'Q: Who is managing my organization?',
            faqAnswer4: 'A: An admin manages each organization.',
            faqQuestion5: 'Q: How I can contact admin from my organization?',
            faqAnswer5: 'A: ',
            faqQuestion6: 'Q: What is a My Bag and how do I create one?',
            faqAnswer6: 'A: My Bag are used to sort your assets and download multiple assets at once. Please refer to the user guide for a detail explanation on how to create My Bag.',
            faqQuestion7: 'Q: How can I upload assets?',
            faqAnswer7: 'A: Please refer to the user guide which has a detailed explanation about the upload process.',
            faqQuestion8: 'Q: What format of the assets I can upload?',
            faqAnswer8: 'A: You can upload images (jpeg, jpg, png, etc) and videos (mp4).',
            faqQuestion9: 'Q: What is metadata?',
            faqAnswer9: 'A: Metadata is a set of data that describes and gives information about other data.',
            faqQuestion10: 'Q: What is difference between tags and metadata?',
            faqAnswer10: 'A: Tags are used to sort assets while metadata is information attached to the file itself.',
            faqQuestion11: 'Q: I don’t see uploaded images. What should I do?',
            faqAnswer11: 'A: Depending on the file size, it will take some time for uploaded assets to appear in the library. However, if it does not appear after an extended period of time, please contact support: \n Tel: 03-6804-2655 \n Email: jphoto-inquiry@jnto.go.jp',
            faqQuestion12: 'Q: Where I can read about fields in the excel for upload?',
            faqAnswer12: 'A: Please refer to the user guide for more information.',
            faqQuestion13: 'Q: Where I can find the excel template for upload?',
            faqAnswer13: 'A: You can find the excel template for upload on excel upload page during the upload process.',
            faqQuestion14: 'Q: Can I download assets?',
            faqAnswer14: 'A: Yes, you can download assets. Please be aware that there are two types of the assets: download free and download with permission. For more details please refer to the user guide with detail explanation about download process.',
            faqQuestion15: 'Q: I cannot download an image. What should I do?',
            faqAnswer15A: 'A: Please use the Report a bug function.',
            faqAnswer15B: 'If you have already closed the window, please use the Report a problem option on the Dashboard page. For more detailed information on how to use it, please refer to the user guide.',
            faqAnswer15C: 'In case you have a problem with using two options above, please contact our support team directly. \n Tel: 03-6804-2655 \n Email: jphoto-inquiry@jnto.go.jp',
            faqQuestion16: 'Q: How to download image with permission request?',
            faqAnswer16: 'A: Please refer to the user guide for a detailed explanation on how to download images with permission request.',
        },
        workflows: {
            admin: {
                userAdmin: 'User Admin',
                userName: 'Name',
                email: 'Email',
                loading: 'Loading',
                editSuccess: 'User edit has been completed', 
                organization: 'Organization',
                projectAdmin: 'Project Admin',
                editUserModalTitle: 'Edit User',
                organizationAdmin: 'Organization Admin',
                createUser: 'Create a new user',
                editUser: 'Edit',
                viewAllUser: 'User Information',
                removeUser: 'Remove users',
                deleteUserConfirm: 'Delete User?',
                createProject: 'Create a new project',
                createOrganization: 'Create a new organization',
                selectSupervisorOrganization: 'Select a supervisor organization',
                selectUserGroup: 'Select a user group',
                projects: 'Projects',
                userGroup: 'User group',
                supervisorOrganization: 'Supervisor organization',
                userCreateSuccess: 'User created successfully!',
                userRemovalSuccess: 'User removed successfully!',
                organizationCreateSuccess: 'Organization created successfully!',
                projectCreateSuccess: 'Project created successfully!',
                editOrganizationProjects: 'Edit organization projects',
                updateOrganization: 'Update organization',
                selectAnOrganization: 'Please select an organization',
                removeOrganization: 'Remove organization(s)',
                reset: 'Reset form fields'
            },
            moderation: {
                approveOrReject: 'Approve or reject upload requests here',
                approveSelected: 'Approve selected uploads',
                rejectSelected: 'Reject selected uploads',
            },
            fileupload: {
                selectOptionTitle: '1. Select option',
                selectOptionQuestion1: '1. Where do you want to upload assets?',
                selectOptionQuestion1Answer1: 'JNTO Photo & Video Library only',
                selectOptionQuestion1Answer2: 'JNTO Photo & Video Library and JOMC',
                selectOptionQuestion2: '2. From whom are these assets?',
                selectOptionQuestion2Answer1: 'JNTO',
                selectOptionQuestion2Answer2: 'Vendors (Local Offices, Travel Agencies etc)',
                selectOptionQuestion3: "Please, select vendor's group.",
                selectOptionQuestion3DefaultDropDown: 'Select the group',
                selectOptionQuestion3Group1: '1 (Prefectures)',
                selectOptionNotesTitle: 'Attention points',
                selectOptionNotes1: 'Please, be aware that by default all assets can be downloaded freely. If you want to restrict this option, please change field in the excel file on upload.',
                attachAssetsTitle: '2. Attach Assets',
                reviewUploads: 'Please review your uploads here',
                maximumFileSize: '• The maximum file size is 300 MB per image and 1000 MB per video.',
                canUploadImagesAndVideos: '• Simultaneous upload of images and videos is supported.',
                attachAssetsNotes1: '• Assets supported formats: JPG, JPEG, PNG, MP4.',
                attachAssetsNotes2: '• Assets can be uploaded in ZIP folder.',
                attachAssetsNotes3: '',
                attachAssetsNotes4: '',
                attachExcelFileTitle: '3. Attach Excel File',
                attachExcelFileNote1: '• Format of the uploading file must be .xlsx format.',
                attachExcelFileNote2: '• To Attach meta-data from the excel file provide the proper filename.',
                attachExcelFileNote3: '• Include format of the file in the filename field. \n Ex.: test-image.jpg',
                downloadTemplateJNTO: 'Download template here (JNTO)',
                downloadTemplateJOMC: 'Download template here (JNTO&JOMC)',
                uploadAssetsTitle: '4. Upload Assets',
                uploadAssetsNotes: 'You can edit meta-data for the assets on this screen. Please fill in information which is marked with * symbol.',
                uploadAssetsNotes2:'',
                uploadAssetsNotes3:'',
                uploadAssetsNotes4:'',
                uploadAssetsNotes5:'',
                uploadAssetsNotes6:'',
                uploadAssetsNotes7:'',
                uploadScrollNotes: 'Please note that you can scroll horizontally in the grid below.',
                restartUpload: 'Restart upload',
                myPendingRequests: 'My pending requests',
                referToUserGuide: 'For more details about upload process, please refer to the ',
                hoverText: 'You can download the latest data you have added/edited on the screen from here. Use this option if you want to save inputted data before uploading it.',
                downloadGrid: 'Download Grid Data',
                validation: {
                    filename: 'File name must be entered correctly',
                    location: 'Location must be entered correctly',
                    prefecture: 'Prefecture must be entered correctly.  Prefecture must be in English characters and begin with a capital letter.',
                    description: 'Description must be entered correctly',
                    photographer: 'Photographer must be entered correctly',
                    requestApproval: 'Approval Required must be entered correctly as true or false',
                    shootingDate: 'Shooting date must be entered correctly in one of the following formats: YYYYMMDD, YYYYMM, or YYYY',
                    from: 'Asset Owner must be entered correctly',
                    purchaseId: 'Purchase ID must be entered correctly',
                    projectName: "Project Name must be entered correctly",
                    validDate: 'Valid date must be entered correctly in the format: YYYYMMDD',
                    prePostApproval: 'Pre/post approval must be entered correctly as true or false',
                    secondaryUseJNTO: 'Secondary Use JNTO must be true',
                    secondaryUseMedia: 'Secondary Use must be entered correctly as true or false',
                    secondaryUseJomcJnto: 'Secondary Use must be entered correctly as true or false',
                    secondaryUseGovernment: 'Secondary Use must be entered correctly as true or false',
                    secondaryUseJOMC: 'Secondary Use must be entered correctly as true or false',
                    trimming: 'Trimming must be entered correctly as true or false',
                    credit: 'Credit must be entered correctly',
                    rightOfPublicity: 'Right of publicity must be entered correctly as true or false',
                    contact: 'Contact must be entered correctly',
                    title: 'Title must be entered correctly and is required for JOMC uploads',
                    theme1: 'Theme1 must be entered correctly and is required for JOMC uploads',
                    theme2: 'Theme2 must be entered correctly',
                    season: 'Season must be entered correctly and is required for JOMC uploads',
                    tags: 'Tags must be entered correctly',
                    copyright: 'Copyright must be true',
                    mediaType: 'Media type must be entered correctly and is required for JOMC users',
                    modelRelease: 'Model Release must be true',
                    secondaryUseMunicipality: 'Secondary Use (Municipality) must be entered correctly as true or false',
                    color: 'Color must be entered correctly as true or false',
                    text: 'Text must be entered correctly as true or false',
                    contactOrganization: 'Contact Organization must be entered correctly',
                    contactRole: 'Contact Role must be entered correctly',
                    contactname: 'Contact Name must be entered correctly',
                    contactPhoneNumber: 'Contact Phone Number must be entered correctly',
                    contactEmail: 'Contact Email must be entered correctly',
                    location2: 'Location2 must be entered correctly and is required for JOMC users',
                    mediaTypeGovernment: 'Media Type Government must be entered correctly as true or false',
                    mediaTypeMedia: 'Media Type Media must be entered correctly as true or false',
                    mediaTypeTravelTrade: 'Media Type Travel Trade must be entered correctly as true or false',
                    mediaTypeMultiple: 'At least one Media Type is required for JOMC users',
                    secondaryUseMultiple: 'Either mediaTypeMedia or mediaTypeTravelTrade must be Yes for JOMC uploads',
                    approvalForExternalUsage: 'Approval for External Usage must be entered correctly',
                    remark: 'Remark must be entered correctly',
                    referenceUrl: 'Reference URL must be entered correctly',
                    departmentInCharge: 'Department in charge must be entered correctly',


                },
                successModal: {
                    title: 'Upload Complete',
                    bodyText2: '*Please note that it usually takes 1 or 2 minutes for the registered material to appear in image gallery, and more than 5 minutes for large file sizes (video, etc.).',
                    button: 'Close and return to dashboard'
                }
            },
            folders: {
                deleteFromBag: 'Remove From Bag',
                downloadWarning: 'This bag contains assets which require approval to download and have not been approved. \n Only assets which do not require approval or which have been approved will be included in the download. ',
                areYouSure: 'Are you sure?',
                renameFolder: 'Rename Bag',
                deleteFolderPrompt: 'Delete Bag?',
                downloadFolder: 'Download bag',
                deleteFolder: 'Delete bag',
                newFolderName: 'New Bag Name',
                searchWithinFolder: 'Search for assets within bag: {{folderName}}',
                requestPermission: 'Request permission for all assets',
                folderUse: 'Use: {{folderUse}}',
                folderHasPermissionImage: 'Contains licensed images',
                back: 'Go Back'
            },
            myRequests: {
                reviewRequests: 'Review your requests here',
                tabLabels: {
                    rejected: 'Rejected',
                    pending: 'Pending',
                    approved: 'Approved'
                }
            },
            myPermissionRequests: {
                deletePermissionsConfirm: 'Cancelling download requests will cancel all permission requests for this bag and remove the request type and reason associated with this bag. Any currently approved images will need to be approved again. If you would like to cancel a single request, please remove the asset from this bag.\n\n Are you sure? ',
                deleteAssetFromFolder: 'Removing this asset from this bag will cancel any download requests for this asset from this bag. \n Are you sure you want to remove? ',
                pendingRequests: 'Pending download requests',
                requestUserOrg: 'Requesting User Orginization',
                requestUser: 'Request User',
                requestReason: 'Request Use Details',
                status: 'Status',
                reviewRequests: 'Review your download approval requests here',
                approveSelected: 'Approve selected requests',
                title: 'Request type',
                rejectSelected: 'Reject selected requests',
                approveSelectedMessage: 'Please confirm - any changes will be final. Requesting user will be given access to download selected assets',
                rejectSelectedMessage: 'Please confirm - any changes will be final. Requesting user will not be given access to download selected assets',
                fromUser: 'From User',
                fromEmail: 'From Email',
                fromOrganization: 'From Organization',
                useType: 'Usage Type',
                modalTitleExisting: 'Bag set to following Use:',
                modalReasonExisting: 'Bag set to following Use Details:',
                downloadUse: 'Bag permission type: {{reason}}',
                downloadDetails: 'Downloads from bag must be used for: {{reason}}',
                usageDescription: 'Usage Description',
                selectFolder: 'Select Bag for Permission',
                folderDetail: 'This asset will be added to a new bag or a selected one.  You will be redirected to the page where you can send the request for permission',
                usageReasonEnterTitle: 'Please Supply Usage Reasons for Download',
                usageReasonEnter: 'Select usage type and enter details for how asset will be used',
                couldNotDownloadNoUsers: 'The following assets can not be downloaded because no users exist in uploading organization:',
                tabLabels: {
                    incoming: 'Incoming Requests',
                    outgoing: 'Outgoing Requests'
                },
                uses: {
                    sns: '①Dissemination of information via SNS',
                    website: '②Dissemination of information via web page ',
                    newsletter: '③Dissemination of information via newsletter',
                    events: '④Utilization at events (travel expos, business meetings, seminars, etc.)',
                    invitation: '⑤Invitation of travel agencies, media, and influencers ',
                    advertising: '⑥Advertising',
                    other: '⑦Other',
                    commercial: 'Commercial',
                    noncommercial: 'Non-Commercial',
                }
            },
            downloadHistory: {
                downloadStartDate: 'Download Start Date: ',
                downloadEndDate: 'Download End Date: ',
                downloadExcel: 'Download usage history',
                viewHistoriesAdmin: 'View download histories for all organizations',
                viewHistories: 'View download histories for organization',
                downloadHistories: 'Download Histories',
                uploader: 'Uploaded by user',
                downloader: 'Downloaded by user',
                uploadOrg: 'Uploader Organization',
                downloadOrg: 'Downloader Organization',
                downloadDate: 'Download Date',
                downloadSizeWarning: 'Download size is over 4GB.  Are you sure you would like to continue?',
                noRequests: 'No download histories'
            },
            deletionSystem: {
                delete: 'Delete',
                confirmTitle: 'Are you sure you want to Delete?',
                confirmText: 'Are you sure you want to delete selected asset?  Asset will be deleted permanently. This action cannot be undone.',
                infoText: '*Once submitted, deletion may take a couple minutes to be completed. After this, page must be refreshed for change to be reflected.',
                confirmTextJOMC: 'WARNING: ASSET EXISTS ON JOMC SITE, AND WILL BE REMOVED FROM BOTH JNTO PHOTO & VIDEO LIBRARY AND JOMC SYSTEM IF DELETED. \n\n Are you sure you want to delete selected asset?  Asset will be deleted permanently. This action cannot be undone.'
            },
            userProfile: {
                yourProfile: 'Your user profile',
                selectLanguage: 'Language preference',
                preferences: 'Preferences',
                information: 'Information',
                creationDate: 'Creation Date:',
                signInAs: 'User Group:',
                email: 'Email Address',
            },
            projects: {
                tagEdit: "Are you sure you want to delete tag: '{{tagName}}'?",
                addToBag1: 'Put the selected assets into a bag',
                addToBag2: 'Create a new bag or add to an existing bag to store your assets.',
                addBagDropDown: 'Add to bag or create new bag',
                addBagSubmit: 'Save',
                numberOfAssets: 'Number of assets selected: {{count}}',
                selectFolder: 'Select a bag for your: {{count}} asset(s)',
                addNewFolder: 'Create New Bag',
                addUploadFolder: 'Add upload bag',
                selectProject: 'Select a project',
                selectProjectToProceed: '**Please select a project to proceed',
                numberOfImagesReturned: 'Images: {{imageCount}} returned out of {{totalImages}} total',
                numberOfVideosReturned: 'Videos: {{videoCount}} returned out of {{totalVideos}} total',
                searchAcrossProjects: 'Search for assets across projects',
                searchWithinProject: 'Search for assets within project: {{projectName}}',
                selectProjectToViewAssets: 'Select a project to view relevant images and videos',
                copiedAssetUrl: 'Asset URL has been copied. Please use with caution'
            }
        },
        form: {
            label: {
                firstName: 'First name',
                lastName: 'Last name',
                email: 'Email address',
                phoneNumber: 'Phone number',
                projectName: 'Project name',
                organizationName: 'Organization name',
                password: 'Password',
                passwordRules: 'Password must be at least 12 characters, including 1 lower case, 1 upper case, 1 special character, and 1 number.  Special characters include the following: = + - ^ $ * . [ ] { } ( ) ? ” ! @ # % & / 	\\ , > < 	\' : ; | _ ~ `',
                verificationCode: 'Verification code',
                newPassword: 'Your new password',
                submit: 'Submit',
                create: 'Submit',
                ok: 'OK',
                cancel: 'Cancel',
                next: 'Next',
                back: 'Back',
                save: 'Save',
                deletePermissions: 'Cancel Approval Requests',
                download: 'Download',
                searchForAssets: 'Search for assets',
                editFilesHere: 'Edit files here',
                dragDropFilesHere: 'Drag and drop files here',
                selectProject: 'Select project',
                selectProjectDescription: 'Choose a project to upload into',
                selectProjects: 'Select projects',
                attachAssets: 'Attach assets',
                attachAssetsDescription: 'Attach your assets to upload',
                attachExcel: 'Attach Excel File',
                attachExcelDescription: 'Attach a Excel File file with the data',
                uploadAssets: 'Upload assets',
                uploadAssetsDescription: 'Edit data here (* denotes required field)',
                selectAnOrganization: 'Select an organization',
                numProjectsSelected: '{{numProjects}} project(s) selected',
                refresh: 'Refresh',
                addTag: 'Add Tag',
                close: 'Close',
                requestApproval: 'Request Approval'

            },
            placeholder: {
                'enterTag': 'Add tag and press enter...'
            },
            errors: {
                errorTitle: 'An Error has Occured',
                errorPopupMessage: 'Please try again or contact support',
                email: 'Please enter a valid email address',
                verificationCode: 'Please enter a valid verification code',
                phoneNumber: 'Please enter a valid phone number',
                firstName: 'Please enter a valid first name',
                lastName: 'Please enter a valid last name',
                projectName: 'Please enter a valid project name',
                organizationName: 'Please enter a valid organization name',
                password: 'Please enter a valid password',
                signinFail: 'Sign in failed with message: {{err}} Please try again or contact support',
                createUserFail: 'Creating user failed with message: {{err}} Please try again or contact support',
                removeUserFail: 'Removing user failed with message: {{err}} Please try again or contact support',
                createOrganizationFail: 'Creating organization failed with message: {{err}} Please try again or contact support',
                createProjectFail: 'Creating project failed with message: {{err}} Please try again or contact support',
                passwordCouldNotBeReset: 'Sorry, your password could not be reset. Please contact support.',
                attachValidExcel: 'Please attach valid Excel File',
                noAssetsFound: 'Sorry, but no assets were found',
                requestFailed: 'Your request has failed with the error: {{message}}. Please try again later or contact support',
                disallowedFileUpload: 'The file: ({{invalidFile}}) is not a valid type',
                invalidZipArchive: 'At least one file did not match the valid extensions (jpg/png/gif/mp4)',
                contactSupport: 'Contact Support'
            }
        },
        locale: {
            english: 'English',
            japanese: 'Japanese'
        },
        manual: {
            welcomePage: {
                menuHeader: 'Introduction',
                title: 'Introduction',
                body: 'The JNTO Photo & Video Library application is designed to provide a place for government agencies and local authorities working with JNTO projects to store and manage their digital assets. The JNTO Photo & Video Library application has been developed to provide a place for government agencies and local authorities working with JNTO projects to store, capture and manage their digital assets.',
                concept: 'There are four main terms/concepts associated with JNTO Photo & Video Library applications',
                conceptDetail1: 'Organisation - The use of JNTO Photo & Video Library is permitted for specific projects or organisational units of JNTO and public offices and local authorities. Different organisations have different access areas and views.Different organisations may have different access areas and views, which should be discussed with JNTO management in advance. Please consult with JNTO management in advance. (e.g.JNTO Regional Departments, Ministry of the Environment National Parks Team, JOMC projects...) etc.',
                conceptDetail2: 'User accounts - these are members of the organisation. As mentioned above, a user can be a regular user or an admin user. A user can only be a member of one organisation.',
                conceptDetail3: 'Asset - An asset can be an image (jpeg, png, jpg etc) or a video (mp4).',
                conceptDetail4: 'Image gallery - storage for all images. (WIP)',
                concept2: 'Range of asset use/how to use them',
                concept2Detail1: 'In principle, stored images and videos can only be used for JNTO projects. However, some of the images and videos available to third parties via JNTO staff were stored in FY2022.',
                concept2Detail2: 'Please be aware that in some cases, individual confirmation with the department which processed the rights may be required.',
                concept2Detail3: 'We ask that you take precautions to prevent the leakage of JNTO \'s internal assets.',
                concept2Detail4: 'As for the rights processing information (e.g., whether trimming is allowed or not) for each asset, please check the information of the asset before using it.',
            },
            userAuth: {
                menuHeader: 'User Authentication',
                title: '2 User Authentication',
                body: 'To log into the JNTO Photo & Video Library system, a user must have an account. User accounts can be created by administrators. For more information on creating user accounts, please refer to page XXX.'
            },
            login: {
                menuHeader: 'User login',
                title: '2.1 User login',
                subTitle: '2. Authentication',
                loginDetailnew1: 'To log in to the JNTO photo & video library, you first need to create an account. Accounts can only be created by users with administrator rights. If you need to create a new account, please contact the Digital Marketing Center at the Japan National Tourism Organization.',
                loginDetail1a: 'You can login to the JNTO photo & video library from the following URL:',
                loginDetail1b: 'Please confirm your initial password in the email sent by the system (no-reply@verificationemail.com) when your account is issued.',
                loginDetail1c: 'If you already have a personal account with the Japan Online Media Center (https://business.jnto.go.jp/), which is operated separately by JNTO, you can use the same password to log in. Note that if you register a JOMC account after creating a J-Photo account, an error will occur. Please contact us at "jphoto-inquiry@jnto.go.jp" to have your account re-registered.',
                loginDetail1d: '',
                title2: 'Language setting',
                loginDetail2a: 'Click the user profile icon in the upper right corner of the screen to display the user profile page as shown below. Here you can see the user information such as name, registered e-mail address, and user group (organization name).',
                loginDetail2b: 'The following page appears when you open the "Preferences" tab. You can select and change the language from "Language preference".',

            },
            resetPassword: {
                menuHeader: 'Reset Password',
                subTitle: '2. Reset Password',
                title: '2.2 Reset Password',
                reset: 'You can reset your password from the user profile page or from the login screen.',
                resetDetail01: '',
                resetDetail02: '1. Changing your password from your user profile page',
                resetDetail03: 'Click on the user profile icon at the top right of the screen.',
                resetDetail032: 'On your user profile page, go to the “Preferences" tab and click on "Reset Your password". Once you click the reset button, you will be forced to log out.',
                resetDetail04: 'A password reset form will be displayed. Enter your email address and click Submit.',
                resetDetail05: '',
                resetDetail06: 'The system will send you a confirmation code to the email address you entered.',
                resetDetail07: 'Enter your email address, the confirmation code you received by email and your new password.',
                resetDetail08: 'You will then be able to login with your new password.',
                resetDetail09: '',
                resetDetail10: '2. Changing your password from the login screen',
                resetDetail11: 'If you forget your password and are unable to log in, you can reset it by clicking on the "Forgot your password?” to reset your password.',
                resetDetail12: 'Click on the "Forgot your password?” on the login screen.',
                resetDetail13: 'Enter your email address and click on submit to complete the password reset form.',
                resetDetail14: 'The system will send you a confirmation code to the email address you have entered.',
                resetDetail15: 'Enter your email address, the confirmation code you received by email and your new password.',
                resetDetail16: 'You will then be able to login with your new password.',
                resetDetail17: 'Note: Your password must contain upper- and lower-case letters, numbers and symbols List of accepted symbols: = + - ^ $ * . [ ] { } ( ) ? ” ! @ # % & / \ , > < \' : ; | _ ~ `',
                resetDetail18: 'Note that the initial password in the welcome mail sent at the time of account issuance will become invalid after 30 days. If you do not login/change your password within 30 days, the password will need to be reissued. \n*If you have a JOMC account, you will not receive a welcome mail and can log in using your JOMC account information.'

            },
            logout: {
                menuHeader: 'User Logout',
                subTitle: '2. User Authentication',
                title: '2.3 User Logout',
                logoutDetail01: "Click on the user profile icon.",
                logoutDetail02: 'From the User Profile page, open the Preferences tab, and click Logout.',
                logoutDetail03: "You will now be logged out of the system.",
            },
            navigation: {
                menuHeader: 'Navigation',
                title: '3 Menu Navigation',
                navigationDetail01: 'Basic navigation  in system',
                navigationDetail02: 'There are two methods of navigation: the Sidebar and the Navigation Menu. The "Sidebar" displays basic user information and a link to the contact form. For information regarding the Navigation Menu, please see below.',
                dashboardDescription: 'Links to frequently used functions.',
                downloadDescription: 'Shows incoming and outgoing download requests.',
                uploaddDescription: 'Upload Assets',
                userGuidedDescription: 'Web Manual',
                myBagDescription: "List of user's bags",
                galleryscription: 'Search for assets',
                adminDescription: 'Users (create and delete users), Organization (create, edit, and delete organizations)',
                profileDescription: 'View user information, select language, logout',
                myBag: 'My Bag',
                assetGallery: 'Asset Gallery',
                adminPage: 'Admin Page',
                profilePage: 'User Profile',
            },
            upload: {
                title: '4.　Upload',
                menuHeader: 'Upload Assets',
                step1: {
                    subTitle: '4 Upload Assets',
                    title: '4.1 Navigate to Upload page',
                    intro: 'There are few ways to navigate to the Upload page',
                    method1: 'From Nivagation menu at the top of the page.',
                    method2: 'From Dashboard page.',
                    img1: 'https://asset.japan.travel/image/upload/w_600,f_auto,fl_lossy,e_improve,e_sharpen/v1611168942/dam-admin/manual/Upload/dam_upload_01b.png',
                },
                step2: {
                    subTitle: '4 Upload Assets',
                    title: '4.2 Select Option',
                    amedments: 'Select where you want to register your assets and where you got them from, then click \'Next\ʼ \n(Image 2)Click on the "Next" button and the screen shown in image 3 will appear.',
                    amedments2: 'Image 2',
                    amedments3: 'Image 3',
                },
                step3: {
                    subTitle: '3 Upload Assets',
                    title: '4.3 Attach Assets',
                    explanations1: 'Assets can be added by "drag and drop" into the white frame in the middle of the screen, or by clicking on the "Add file" button.',
                    notesTitle: 'Notes:',
                    notes1: 'You can upload assets by both individual file or zip file. If you drop both types of files at the same time, only the zip file will be uploaded. Please be careful.',
                    explanations2: 'Once you have added your assets, you will see a screen similar to the one below. Make sure that all the assets you want to add are displayed, then click on the \'Next\' button.',
                },
                step4: {
                    subTitle: '4 Upload Assets',
                    title: '4.4 Attach Excel File',
                    explanations1: 'The next step is to download an excel file where you can enter the file name and information for your assets. Click on "Download template" to download the file template.\nFollow the instructions displayed on the downloaded excel file to enter your asset information.',
                    explanations2: '*After uploading the Excel file to the system, you can enter and edit items, except for the file name',
                    notesTitle: 'Notes:',
                    notes1: 'The file name of the asset cannot be changed after upload, so please take care when choosing a name to ensure that the asset is recognisable from similar images.',
                    explanations3: 'Once you have added Excel, you will see a screen similar to the one below. Click on the [Next] button.',
                },
                step5: {
                    subTitle: '4 Upload Assets',
                    title: '4.5 Upload Assets',
                    explanations1: 'Fields that are required to be filled or were left blank in the excel file are highlighted in pink. A notification will appear in red at the top of the table.',
                    explanations2: 'You can edit highlighted fields by clicking on to them. You can also use functions such as copy and paste.',
                    explanations3: 'Fields with "*" marks are mandatory.',
                    explanations4: 'When you click on the header of each item, you can sort the order of the assets you will be uploading.',
                    explanations5: 'Example: Sorting by file name.',
                    explanations6: 'You can apply a filter by clicking on "Filter Rows".',
                    notesTitle: 'Notes:',
                    notes1: 'For instance, when you are uploading a large number of assets and you would like to split your edits into several sessions, you can click "Download Excel" to download the Excel file being edited, and resume work later.',
                    explanations7: "After you have finished the input process, click on the \"Save\" button to complete the asset upload process.\nYou can go back to the previous step and make changes by clicking on the \"Back\" button.",
                },
            },
            assets: {
                menuHeader: 'Assets',
                title: '5. Assets',
                body: 'Assets are images (jpeg, png, jpg, etc.) or videos (mp4) that are managed on the JNTO Photo & Video Library system. Different user groups can view different materials. User group settings are determined by system administrators.',
                assetsDetails: {
                    menuHeader: '5.1 Assets',
                    subTitle: '5. Assets',
                    title: '5.1 Assets: Details (Continued)',
                    detail01: '“Assets” are images (jpeg, png, jpg etc.) or videos (mp4) stored in the JNTO Photo & Video Library.',
                    detail02: 'Users can manage their assets in several ways:',
                    detail03: '',
                    detail04: 'You can create multiple “My Bags” to download your assets.',
                    detail05: 'Submit requests for permissions in advance for those assets which requires permissions for use. When you receive a notification from the department in charge, follow the process to download the assets.',
                    detail06: 'You can filter assets by various categories displayed in the filter, such as prefectures',
                    detail07: 'Adding information related to the assets and tags as well as editing and deleting can only be done by account holders who belong to the department in charge of the assets. If you are authorized for editing, the "EDIT" button will be displayed under the image after clicking the thumbnail. Multiple items will be displayed when you click the button, and information can be edited from there.',
                    notes: 'Notes:',
                    notes1: 'Only account holders who belong to the department in charge of the assets can delete assets in the system.',
                    notes2: 'If you are downloading both images and videos, please download them separately.',
                    notes3: 'To avoid errors, split large volumes of assets into a few batches when downloading.',
                },
                assetsGallery: {
                    menuHeader: '5.2 Image gallery',
                    subTitle: '5. Assets',
                    title: '5.2 Asset Gallery',
                    intro: 'All assets that you have permission to view can be found in the Asset Gallery.',
                    detail01: 'The \ʻImage Gallery\' page has a search bar, sorting options and JNTO/JOMC filtering to find assets. The 10 sort items displayed under the filters can be used to narrow down the assets.',
                    detail02: '1. Search bar: Allows you to search by one or more keywords.',
                    detail03: '2. Sort: the assets can be sorted by date, size or file name and download numbers.',
                    detail04: '',
                    detail05: '3. JNTO/JOMC: You can narrow down your search to assets registered only with the JNTO Photo & Video Library and materials registered with both the Japan Online Media Center (JOMC) and the JNTO Photo & Video Library.',
                    detail06: 'Please click on the button for "JNTO" or "JOMC" to make use of this service.',
                    detail07: '4. Filter: You can filter assets by 10 factors, including type of assets, image ratio, prefecture, season, requires application for permission to use, as well as content management IDs. You can filter by multiple criteria from each item.',
                    detail08: 'Each thumbnail shows the name, prefecture and content ID of asset. Click on the thumbnail to view the details of the asset. More information will be displayed when you click ”VIEW MORE DETAILS”. *When using assets, be sure to confirm information such as whether the asset can be edited, and if credits need to be added.',
                    detail09: 'If a tag has been added to the asset, it will be displayed in blue or orange. Blue (manual tags) are tags that have been added manually by the administrator, while orange (auto tags) are tags that have been added automatically when you upload your asset.',
                    detail10: 'Information details you can view:',
                    detail11: 'Whether or not a permission request is required for use ("key icon" is displayed on assets that require a request).',
                    detail12: 'Name of image, place where it was taken, prefecture, and whether it can be used for various secondary uses.',
                    detail13: 'Tags (manual tags are displayed in blue, auto tags in orange)',
                    detail14: 'Other detailed information and items can be viewed from the right side of the image below.',
                    detail15: 'The "EDIT" button under the image only appears if you are authorized to edit the information.',
                    detail16: '・Delete tags',
                    detail17: 'You can remove a tag from an asset by clicking on the \'x\' button in the top right corner of the tag.',
                    detail18: '・Add tags',
                    detail19: 'You can add a new tag by clicking on the "Add Tag" button. It brings up the tag entry field, where you can type in text, and press Save to add the tag.',
                    detail20: 'There are two ways to edit asset information, and only accounts that belong to the department in charge of the asset can make edits.',
                    detail21: 'If you are authorized to edit, a "pencil icon" will appear on the thumbnail in the image gallery, and an "EDIT" button will appear below the image after you click on the thumbnail. If you click on the "pencil icon" or "EDIT" button, the information edit section will appear as shown in 3, and the information can be edited from here. After editing the information, click the red "UPDATE" button to update the information.',
                    detail22: 'Admin users can retrieve the Cloudinary URL of the asset. Simply hover over the thumbnail image of the asset and click on the external link icon.',
                    detail23: 'The assets in the JNTO Photo & Video Library can be divided into two categories:',
                    detail24: '1. Assets you donʼt need permission to use (You can download immediately)',
                    detail25: '2. Assets you need to request permission for use',
                    detail26: 'If the asset requires "Permission" for use, a "Key Icon" is displayed on the thumbnail of the asset. These assets are not available for immediate download. To use them, you will need to submit a request and get permission from the department in charge of the assets.',
                    detail27: 'Assets not requiring permission for use can be downloaded from a single asset. A single asset can be downloaded directly without putting it in a bag. Select the material you need from the Image Gallery and click “Download.”',
                    detail28: 'To download multiple assets in one batch, you will need to save them in My Bag. Clicking on the tick box in the grid of assets will bring up "Put the selected assets into a bag" section. Select the suitable category from "Add to bag or create new bag". Whether or not you need to apply for permission to use the asset, you must store the assets in your My Bag before downloading them.\nNote: If you are downloading a large volume of assets, split them into several batches to avoid errors. Also, if you are downloading both images and videos, batch them by the same type of assets.',
                    detail29: 'General users can only delete assets that are managed by their own organization. Administrative users are authorized to delete all assets.',
                    detail30: 'If you wish to delete an asset, please click on the Delete button as shown on the right.',
                    label1: 'Basic operation of the image gallery',
                    label2: 'View detailed information about the asset',
                    label3: 'Edit asset tags',
                    label4: 'Edit asset information',
                    label5: 'Getting a link to the asset (administrator-only feature)',
                    label6: 'Request permission to use asset',
                    label7: 'Asset download',
                    label8: 'Save assets in My Bag',
                    label9: 'Delete assets',
                    label10: '',
                },
                assetsEdit: {
                    menuHeader: '5.3 Asset Details: Edit Asset and View Detailed Information',
                    subTitle: '5. Asset',
                    title: '5.3 Asset Details: Edit Asset and View Detailed Information',
                    intro01: 'The thumbnail of each asset shows the name, prefecture, and size of the asset. To view details of an asset, click on the thumbnail.',
                    intro02: 'If a tag has been assigned to the asset, it will be displayed in blue or orange. Blue ("manual tags") are tags that have been manually added by the administrator. Orange ("auto tags") are tags that are automatically assigned when you upload the asset. ',
                    intro03: 'Tags: Manual Tags are displayed in blue. Auto Tags are be displayed in orange.',
                    intro04: 'Image name, shooting location, prefecture, and secondary use permissions. ',
                    intro05: 'Whether permission is needed to download this asset.',
                    detail01Title: 'Editing Asset Tags',
                    detail01: 'Deleting tags',
                    detail02: 'You can delete a tag from an asset by clicking the "x" button in the upper right corner of the tag.',
                    detail03: 'Adding Tags',
                    detail04: 'You can add a new tag by clicking the "Add Tag" button.',
                    detail05Title: 'Get link to asset (feature is only available to administrators)',
                    detail05: 'Admin users can retrieve the URL of an asset. This can be obtained by hovering over the thumbnail image of the material and clicking on the external link icon in the upper right corner.',
                },
                assetsDelete: {
                    menuHeader: '5.4 Delete Assets',
                    subTitle: '5. Asset',
                    title: '5.4 Delete Assets',
                    detail01: '1. General users can only delete assets that they have uploaded themselves. Administrator users are able to delete all assets, so please take care when choosing assets to delete. ',
                    detail02: 'View the asset details and click on the "Delete" button.',
                    detail03: '2. The following confirmation window will appear. Confirm the details and click "OK" in order to delete.',
                    detail04: '3. Clicking OK will delete the asset. Deletion may take time to take effect.',
                    detail05: '4. The deletion is now complete.'
                },
            },
            myBag: {
                menuHeader: 'My Bag',
                subTitle: '6. Mm Bag',
                title: '6. My Bag',
                note: 'Caution:',
                intro: 'Materials to be downloaded are managed in Bags. Users can create their own Bags, collect and manage assets they wish to download, download groups of assets, and request permission to download.',
                create: {
                    menuHeader: 'Creating a bag',
                    title: '6.1 Creating a bag',
                    detail01: 'Bags are a place where you can collect and manage the assets you wish to download. You can also use Bags to request permission to download images that require permission.',
                    detail02Title: 'There are two ways to create a Bag:',
                    detail02: 'In the "Asset Gallery", click the checkbox in the asset grid.',
                    detail03: 'You will be prompted to create a Bag when you apply for Permission to Use.',
                    note01Detail: 'If your Bag contains at least one asset that requires permission to download, the bag will be used for the permission request. If needed, you can create a My Bag for a single asset.',
                    detail04: 'To create a Bag, you must first select an asset.',
                    detail05: 'To select an assets, select the checkbox in the grid.',
                    detail06: 'When you select an asset, you will be asked to either create a new bag or choose an existing bag.',
                    note02Detail: 'When adding materials that require permission to download to an existing bag, it is assumed that the assets in the bag will be used for the same purpose. ',
                    detail07: 'When you add an asset to an existing bag, you will be redirected to the My Bag page. When you create a new bag, the following screen will be displayed. Enter a name for the new bag and click the save button.',
                    detail08: 'Click the save button to go to the My Bag page.',
                    detail09: 'To view all Bags, click on the "MY" icon in the navigation menu.'
                },
                edit: {
                    menuHeader: 'Edit Bag Name',
                    title: '6.2 Edit Bag Name',
                    intro: 'On the My Bags page, you can edit the name of a bag or delete an existing bag.',
                    detail01: 'Go to the My Bags page. Click on the pencil icon (Edit) of the bag you want to rename.',
                    detail02: 'The following screen will be displayed. Enter a new bag name, and click the save button to update the bag to the the new name.',
                },
                delete: {
                    menuHeader: 'Delete a Bag',
                    title: '6.3 Delete a Bag',
                    note01Detail: 'Deleting a bag will not delete the assets it contains. It only deletes the bag.',
                    detail01: 'There are two ways to delete a Bag.',
                    detail02: 'Delete from the My Bag page.',
                    detail03: 'You can use the trash can icon on the My Bag page to delete a bag.',
                    detail04: 'The following screen will be displayed. Once you have confirmed you would like to delete this bag, click OK to proceed.',
                    detail05: 'Delete from the Bag Detail page',
                    detail06: 'Navigate to view the contents of a specific bag. Click the "Delete Bag" button at the top of the page to delete it.'
                }
            },
            download: {
                menuHeader: 'Download Assets (Permission System)',
                subTitle: '7. Download',
                title: '7. Download',
                note: 'Caution:',
                intro: 'Downloading materials in bulk can be done from the My Bag details page. When the download is executed, the materials will be downloaded in a compressed file (zip) format.',
                detail01: 'If your bag contains materials for which you need to apply for permission, materials for which you do not need permission and materials for which your permission request has been approved will be downloaded. \nIf your bag contains materials for which you need to apply for permission, materials for which you do not need permission and materials for which your permission request has been approved will be downloaded. Materials with rejected permission requests, pending permission requests, or that require permission but have not been requested will not be downloaded.',
                detail02: 'For detailed instructions on how to apply for permission, please see page XXX.',
                detail03: 'Download assets',
                detail04: 'Assets must be added to a bag in order to download. When you select an assets, you will be asked whether you want to create a new bag or add to an existing bag.',
                detail05: 'Some materials require permission to download and others do not.',
                detail06: 'A key icon will appear on the asset when you need to request permission to download it.',

                step1: {
                    menuHeader: 'ownloading Materials: Materials that Do Not Require Permission to Use',
                    title: '7.1 Downloading Materials: Materials that Do Not Require Permission to Use',
                    intro: 'If you do not need to apply for permission to download the asset, you are can download it directly from My Bag.',
                },
                step2: {
                    menuHeader: 'Download Assets',
                    title: '7.2 Downloading Assets: Assets that Require Permission to Download',
                    intro: 'By adding assets to your My Bag, you will be able to apply for permission to download them. If you would like to submit a request to download, please click on "Request Approval".',
                    detail01: 'The following screen will appear.  Please provide the type of use (commercial or non-commercial) and the purpose for downloading the asset.',
                    detail02: 'Click "OK" when you have completed the form. Once you have clicked "OK", your application will be sent to the owner of the asset, and you can wait for the result. (It may take a few days to receive the result).  You cannot cancel or change the content of the application once it has been submitted.',
                    detail03: 'If the permission to download the asset is approved, the "key icon" will change to the "unlocked icon".',
                    detail04: 'You can check the status of your permission request on the Download Requests page. The contents are divided into Incoming Requests and Outgoing Requests.',
                    detail05: 'Table of received permission requests.',
                    detail06: 'This page is displayed when you or your organization have received a request to download an image you are the owner of. You can approve or reject the request here.',
                    detail07: 'If you have an incoming permission request that needs attention, you will see a blue icon next to the Download Requests in the navigation menu.',
                    note: 'Caution',
                    detail08: 'You must agree to the Terms of Use before you can download any materials. Please read the terms of use and scroll to the bottom in order to agree to terms. Check the box and click "OK" to start the download.',
                    detail09: 'If the total size of the download exceeds 4GB, a warning will be displayed and you will be asked if you want to continue.'
                }
            },
            admin: {
                menuHeader: 'Admin pages',
            }
        },
        dashboard: {
            uploadAssets: 'Upload Assets',
            downloadRequest: 'Download Requests',
            downloadHistory: 'Download History',
            userGuideDB: 'User Guide',
            myBag: 'My Bag',
            faq: 'FAQ',
            imageGallery: 'Image Gallery',
        },
        contactForm: {
            title: 'Contact Form',
            subject: 'Subject',
            option1: 'Inquiry about JNTO Photo & Video Library functionality',
            option2: 'Submit a bug',
            option3: 'Other',
            inputfield: 'Title',
            message: 'Message',
            cancel: 'Cancel',
            send: 'Send',
            placeholder: 'Enter contact message',
            success: 'Thank you for contacting JNTO Photo & Video Library support. Our support team will reach out to you shortly'
        }
    }
};
